import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { AccessControl } from '@eggplant/context'
import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import { LinkToAddMonitorConfig } from '@eggplant/routing'
import { LinkToMonitorRunnerDoc } from '../links'
import { Path } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const description = `The Runner is where you can schedule and run monitor config and view the results of the runs.

Before you can use the Runner, you must have at least one Monitor Config.

🤟 Let’s start by creating a new monitor config!`

const renderButton = () =>
  <AccessControl isHiddenIfDenied>
    <LinkButton
      title='New Monitor Config'
      variant='primary'
    >
      <LinkToAddMonitorConfig>
        <HiPlus
          aria-hidden
          size='19.2px'
        /> New Monitor Config
      </LinkToAddMonitorConfig>
    </LinkButton>
  </AccessControl>

const MonitorRunnerIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<Path />}
        renderLink={<LinkToMonitorRunnerDoc />}
        title='Runner'
      />
    </div>
  </div>

export default MonitorRunnerIntro
